import { breadcrumbsContent } from "../breadcrumbs/BreadcrumbsContent";
import useTranslation from "../CustomHooks/useTranslation";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import CheckboxMap from "./CheckboxMap";

interface CheckBoxWithTitleProps {
  title: string;
  CheckBoxArray: string[];
  disabledCheckBox?: string[];
  handelCheckBox: (id: string, isChecked?: boolean) => void;
  checkedArray: string[];
  padding?: string;
  error?: string;
  required?: boolean;
}
const CheckBoxWithTitle = ({
  title,
  handelCheckBox,
  checkedArray,
  CheckBoxArray,
  padding,
  disabledCheckBox,
  error,
  required
}: CheckBoxWithTitleProps) => {
  const { translate, notEnglish } = useTranslation(breadcrumbsContent)
  return (
    <div dir={notEnglish ? "rtl" : "ltr"}>
      <div className="flex  pt-8 pb-4 gap-1">
        <h1 className={`text-heading3 text-primary_text underline`}>
          {translate(title)}
        </h1>
        {required && <span className="text-negative">*</span>}
      </div>
      <div className={`flex ${padding ? padding : ' pl-1.5 pr-9'} ${error !== "" ? "" : "pb-5" } w-full`} id={title.toLowerCase().replace(/ /g, "_")}>
        {CheckBoxArray.map((item) => (
          <div className="w-[180px]">
            <CheckboxMap
              options={[item]}
              handelCheckBox={handelCheckBox}
              checkedArray={checkedArray}
              className="flex-col"
              disabledCheckBox={disabledCheckBox}
              error={error}
            />
          </div>
        ))}
      </div>
      {error && <ErrorMessage errorMessage={error || ''} />}
    </div>
  );
};

export default CheckBoxWithTitle;
